import { EcommerceServiceV1Impl } from './v1/ecommerce-service';
import { EcommerceStorage } from './common/storage';
export * from './v1/type';
export * from './common/type';
export const ecommerceFeatureServiceDefinition = {
    id: 'e-commerce-service',
    dependencies: {
        featureServices: {
            'navigation-service': '1.0.0',
            's2:history': '^2.0.0',
        },
    },
    optionalDependencies: {
        featureServices: {
            's2:logger': '1.0.0',
        },
    },
    create: (env) => {
        const navigationService = env.featureServices['navigation-service'];
        const logger = env.featureServices['s2:logger'];
        const featureServiceV1 = new EcommerceServiceV1Impl(navigationService, 'ecommerce:checkout', new EcommerceStorage(window.sessionStorage, logger || console));
        return {
            '1.0.0': () => ({
                featureService: featureServiceV1,
            }),
        };
    },
};
//# sourceMappingURL=index.js.map